import { convertFromESTToLocal } from '@/utils/date/temporary';
import type { LossAndDamageClaim } from '@/views/screens/Claims/types';

import type { ClaimsListResponse } from './basic/api';

export const normalizeClaimsList = (data: ClaimsListResponse): ClaimsListResponse => {
  if (!data) {
    return {
      claimsData: [],
      footerData: {
        closedClaim: 0,
        filedAmount: 0,
        holdClaim: 0,
        openClaim: 0,
        paidAmount: 0,
        totalClaim: 0,
      },
    };
  }

  const normalizedClaims: LossAndDamageClaim[] =
    data.claimsData?.map((claim) => ({
      ...claim,
      claimCloseDate: convertFromESTToLocal(claim.claimCloseDate),
      createdOn: convertFromESTToLocal(claim.createdOn),
      dateFiled: convertFromESTToLocal(claim.dateFiled),
      modifiedOn: convertFromESTToLocal(claim.modifiedOn),
    })) || [];

  return {
    ...data,
    claimsData: normalizedClaims,
  };
};
